import onDOMContentLoaded from "../../base/util/dom/onDOMContentLoaded";
import BaseAccordion from "../../components/base-accordion/base-accordion";

class SubAccountAccordion {
    protected subaccountAccordion: BaseAccordion |  undefined;
    protected showAllButton: HTMLElement | undefined | null;

    constructor(element: HTMLElement) {
        let accordionElement = element.querySelector('.as__accordion');

        if (!(accordionElement instanceof HTMLElement)) {
            console.error('SubaccountAccordion: Accordion element not found');
            return;
        }

        this.subaccountAccordion = new BaseAccordion(accordionElement);
        this.showAllButton = element.querySelector('.dws__subaccount__show-all-licenses') as HTMLElement;

        if (!(this.showAllButton instanceof HTMLElement)) {
            console.error('SubaccountAccordion: show all button not found');
            return;
        }

        this.showAllButton.addEventListener('click', this.toggleAccordionItems.bind(this))
    }

    toggleAccordionItems() {
        this.subaccountAccordion?.getItems().forEach((item) => {
            if (!item.open) {
                item.toggle.click();
            }
        })
    }
}

onDOMContentLoaded(() => {
    let element = document.querySelector('.as__subaccount');

    if (!(element instanceof HTMLElement)) {
        return;
    }

    new SubAccountAccordion(element);
});
